import { render } from "./search_page.vue?vue&type=template&id=00f2500b"
import script from "./search_page.vue?vue&type=script&lang=js"
export * from "./search_page.vue?vue&type=script&lang=js"

import "./search_page.vue?vue&type=style&index=0&id=00f2500b&lang=css"
script.render = render

export default script